import Etiqueta from '../../../components/3catinfo/Etiqueta';
import __isEmpty from 'lodash/isEmpty';

const mergeAgrupacionsTags = ({ agrupacions, tags }) => {
    const arrAgrupacions = Array.isArray(agrupacions) ? agrupacions : [];
    const arrTags = Array.isArray(tags) ? tags : [];
    return [...arrTags, ...arrAgrupacions];
};

const Etiquetes = (props) => {
    const { id, className, exclou } = props;
    const arrEtiquetes = mergeAgrupacionsTags(props);

    const etiquetes = [
        { id: 'ANALISIS', tipus: 'outstanding' },
        { id: 'ULTIMAHORA', tipus: 'highlight', text: 'Última hora' },
        { id: 'VERIFICACIO', icona: 'info_verifica', tipus: 'outstanding', showText: false, estil: 'info_verifica' }
    ];

    const filteredAgrupacions = arrEtiquetes.filter((item) => !exclou?.split(',').includes(item.id));

    if (!__isEmpty(filteredAgrupacions)) {
        return (
            <>
                {etiquetes
                    .filter((etiqueta) => filteredAgrupacions?.some((item) => item.id === etiqueta.id))
                    .map((etiqueta) => (
                        <Etiqueta
                            key={`etiqueta-${id}-${etiqueta.id}`}
                            text={
                                etiqueta.text ||
                                filteredAgrupacions?.find((item) => item.id === etiqueta.id && etiqueta.showText !== false)?.desc
                            }
                            icona={etiqueta.icona}
                            tipus={etiqueta.tipus}
                            estil={etiqueta.estil}
                            className={className}
                        />
                    ))}
            </>
        );
    } else {
        return <></>;
    }
};

export default Etiquetes;
